import { render, staticRenderFns } from "./IconIncrease.vue?vue&type=template&id=1cfcf152&scoped=true"
import script from "./IconIncrease.vue?vue&type=script&lang=js"
export * from "./IconIncrease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfcf152",
  null
  
)

export default component.exports